import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";
import AbbreviatedMillionNumberFormat from "../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import IncomeStatementWidget from "../../../finance/widgets/income-statement";

class TeamReportsSection5Step4 extends PureComponent {
  get left_content() {
    const { costOfSales, holdingCosts } = this.props;

    return (
      <span>
        <u>Financial Impact of Your Decisions</u>
        <br />
        <br />
        Operation decisions impact the following line items:
        <br />
        <br />- <b>Cost of Sales (COS):</b> Your COS of{" "}
        <AbbreviatedMillionNumberFormat
          value={costOfSales}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        is the cost of the products that were sold (i.e. product costs).
        <br />
        <br />- <b>Holding Costs:</b> Your holding costs of{" "}
        <AbbreviatedMillionNumberFormat
          value={holdingCosts}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        is the costs of holding unsold inventory.
        <br />
        <br />- <b>Gain or Loss of Sales:</b> This non-operating costs is a
        result of selling your production lines (i.e. machines).
        <br />
        <br />
        To learn more about what impacts these Operating Expenses, please review
        the following content:
        <br />
        <TypeformLink title="Product Costs" url={TypeformUrls.PRODUCT_COSTS} />
      </span>
    );
  }

  get right_content() {
    const { incomeStatement, current_year } = this.props;

    return (
      <IncomeStatementWidget
        incomeStatement={incomeStatement}
        current_year={current_year}
      />
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Operational Analysis"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection5Step4;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-5/step-4.js